export default __webpack_public_path__ + "static/media/zoo5.68c76992.webp";